import { render } from "./CatsView.vue?vue&type=template&id=7d63d551&scoped=true"
import script from "./CatsView.vue?vue&type=script&lang=js"
export * from "./CatsView.vue?vue&type=script&lang=js"

import "./CatsView.vue?vue&type=style&index=0&id=7d63d551&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d63d551"]])

export default __exports__